export default __webpack_public_path__ + "static/media/logo-yay-64.92189d70.png";